module.exports = "/static/assets/19d1199b045ef18f4ba3c4280b953655.png";